export default __webpack_public_path__ + "images/voucher-card-old2.c6e94a3f4e67d75f3f6020313b3ee83a.png";